import React from "react";
import { Bell, Calendar, X, MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface NotificationItemProps {
  id: string;
  type: string;
  message: string;
  timeAgo: string;
  isRead: boolean;
  onMarkAsRead: (id: string) => void;
}

const getIcon = (type: string) => {
  switch (type) {
    case "ADMIN_MESSAGE":
      return <MessageSquare className="h-4 w-4 text-primary" />;
    case "BOOKING_REMINDER":
      return <Calendar className="h-4 w-4 text-primary" />;
    case "NEW_BOOKING_TODAY":
      return <Bell className="h-4 w-4 text-primary" />;
    case "CANCELLATION_TODAY":
      return <X className="h-4 w-4 text-destructive" />;
    default:
      return <Bell className="h-4 w-4 text-primary" />;
  }
};

export const NotificationItem: React.FC<NotificationItemProps> = ({
  id,
  type,
  message,
  timeAgo,
  isRead,
  onMarkAsRead,
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isRead) {
      onMarkAsRead(id);
    }
  };

  return (
    <Button
      type="button"
      variant="ghost"
      className={cn(
        "w-full justify-start h-auto py-3 px-3 hover:bg-accent/50 transition-colors",
        !isRead && "bg-primary/5"
      )}
      onMouseDown={(e) => e.preventDefault()}
      onClick={handleClick}
    >
      <div className="flex items-start gap-3 w-full text-left">
        {!isRead && (
          <div className="mt-2 h-2 w-2 rounded-full bg-primary flex-shrink-0" />
        )}
        <div className="mt-0.5 flex-shrink-0">{getIcon(type)}</div>
        <div className="flex-1 min-w-0">
          <p className={cn(
            "text-sm leading-snug mb-1",
            !isRead ? "font-semibold text-foreground" : "font-medium text-muted-foreground"
          )}>
            {message}
          </p>
          <p className="text-xs text-muted-foreground">{timeAgo}</p>
        </div>
      </div>
    </Button>
  );
};
